import { Alert } from '@mui/material';

export const AssessmentCrisisAlert = () => (
  <Alert severity="info" sx={{ mt: 3 }}>
    If you or someone you know is in crisis, call 911 or contact the Suicide and
    Crisis Hotline at 988
  </Alert>
);
